import { ArrowRight, Sparkles } from 'lucide-react';
import { Link } from 'react-router-dom';
import { useAuth, useLanguage } from '../../context';

const CastingCTA = () => {
  const { t } = useLanguage();
  const { user } = useAuth();
  return (
    <section className="py-20 bg-gradient-to-r from-[#313131] to-[#404040] relative overflow-hidden">
      {/* Background Pattern */}
      <div className="absolute inset-0 opacity-5"
        style={{
          backgroundImage: `radial-gradient(circle at 4px 4px, rgba(179, 209, 48, 0.8) 3px, transparent 0)`,
          backgroundSize: '80px 80px'
        }}>
      </div>

      <div className="relative z-10 max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 text-center text-white">
        {/* Icon */}
        <div className="flex justify-center mb-8">
          <div className="w-24 h-24 bg-[#b3d130] rounded-full flex items-center justify-center">
            <Sparkles className="text-[#313131]" size={40} />
          </div>
        </div>

        {/* Heading */}
        <h2 className="text-4xl md:text-6xl font-bold mb-8">
          Need talent? <span className="text-[#b3d130]">We've made it easy.</span>
        </h2>

        {/* Description */}
        <p className="text-xl text-gray-300 mb-12 max-w-4xl mx-auto leading-relaxed">
          Submit your casting brief, and we'll get back to you with a custom quotation and
          a handpicked selection of the most suitable talents from our verified library.
        </p>

        {/* Process Steps */}
        <div className="grid md:grid-cols-3 gap-8 mb-12">
          <div className="bg-white/10 backdrop-blur-sm rounded-2xl p-8 hover:bg-white/15 transition-colors duration-300">
            <div className="w-12 h-12 bg-[#b3d130] rounded-full flex items-center justify-center mx-auto mb-4 text-[#313131] font-bold text-xl">
              1
            </div>
            <h3 className="text-xl font-semibold mb-3">Submit Brief</h3>
            <p className="text-gray-300">Tell us about your project requirements and vision</p>
          </div>

          <div className="bg-white/10 backdrop-blur-sm rounded-2xl p-8 hover:bg-white/15 transition-colors duration-300">
            <div className="w-12 h-12 bg-[#b3d130] rounded-full flex items-center justify-center mx-auto mb-4 text-[#313131] font-bold text-xl">
              2
            </div>
            <h3 className="text-xl font-semibold mb-3">Get Recommendations</h3>
            <p className="text-gray-300">Receive curated talent selections within 24 hours</p>
          </div>

          <div className="bg-white/10 backdrop-blur-sm rounded-2xl p-8 hover:bg-white/15 transition-colors duration-300">
            <div className="w-12 h-12 bg-[#b3d130] rounded-full flex items-center justify-center mx-auto mb-4 text-[#313131] font-bold text-xl">
              3
            </div>
            <h3 className="text-xl font-semibold mb-3">Start Creating</h3>
            <p className="text-gray-300">Begin your project with perfect talent matches</p>
          </div>
        </div>

        {/* CTA Button */}

        {user && user.role === "client" && (
          <Link
            to="/casting-brief"
            className="group bg-[#b3d130] text-[#313131] px-8 py-4 rounded-full font-semibold text-lg hover:bg-white transition-all duration-300 transform hover:scale-105 flex items-center mx-auto"
          >
            {t("talents.cta.brief") as string}
            <ArrowRight
              size={20}
              className="ml-2 group-hover:translate-x-1 transition-transform duration-300"
            />
          </Link>
        )}

        <p className="text-gray-400 mt-6">
          Free consultation • 24-hour response • Custom quotations
        </p>
      </div>
    </section>
  );
};

export default CastingCTA;